import api from "../configurations/http-common";


export const getAllMobileApiVersion = async (pageNumber, pageSize, filterValue) => {
    return api.securedAxios().post("/web/mobileVersion/get?pageNumber=" + pageNumber + "&pageSize=" + pageSize, filterValue)
}

export const addMobileVersion = async (formData) => {
    return api.securedAxios().post("web/mobileVersion/create", formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    })
};

export const getMobileVersionById = async (id) => {
    return api.securedAxios().get("/web/mobileVersion/getMobileVersionById?id=" + id);
}


export const deleteMobileVersion = async (id) => {
    return api.securedAxios().delete("web/mobileVersion/deleteById?id=" + id);
};

export const updateMobileversion = async (request, id) => {
    return api.securedAxios().put("web/mobileVersion/update/" + id, request);
}
